import { useGql } from '#imports'
import { getSdk as defaultGqlSdk } from '#gql/default'
export const GqlSdks = {
  default: defaultGqlSdk,
}
export const GqClientOps = {"default":["Content","Elements","HyperLink","Node","SEO","Video","home","instagram","location","menus","page","post","posts","settings"]}
export const GqlHome = (...params) => useGql()('home', ...params)
export const GqlInstagram = (...params) => useGql()('instagram', ...params)
export const GqlLocation = (...params) => useGql()('location', ...params)
export const GqlMenus = (...params) => useGql()('menus', ...params)
export const GqlPage = (...params) => useGql()('page', ...params)
export const GqlPost = (...params) => useGql()('post', ...params)
export const GqlPosts = (...params) => useGql()('posts', ...params)
export const GqlSettings = (...params) => useGql()('settings', ...params)